window.Popup = {
    openPopup: function ({key, props}) {
        window.sellsyapp.$store.state.popupPanel[key].props = props
        window.sellsyapp.$store.state.popupPanel[key].display = true
    },
    closePopup: function (key) {
        window.sellsyapp.$store.state.popupPanel[key].display = false
    }
}
